import { render, staticRenderFns } from "./index.vue?vue&type=template&id=167d5f34&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167d5f34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('167d5f34')) {
      api.createRecord('167d5f34', component.options)
    } else {
      api.reload('167d5f34', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=167d5f34&scoped=true&", function () {
      api.rerender('167d5f34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/web/info/index.vue"
export default component.exports